<!-- eslint-disable vue/multiline-html-element-content-newline -->

<template>
  <component :is="component.is" :class="b()" v-bind="component.attrs"
    ><slot
  /></component>
</template>

<script src="./scripts.js" />

<style module src="./styles.scss" lang="scss" />
